export { isBottomNavMoreRoute, isNavItemActive, navItemPathname, } from './nav-active';
/** Empty string = same-origin requests (Docker / Traefik). */
export const API_BASE_URL = typeof API_PUBLIC_URL !== 'undefined'
    ? API_PUBLIC_URL.replace(/\/+$/, '')
    : 'http://localhost:3100';
/** Разделы бокового меню P0 (desktop). */
export const NAV_SECTIONS = [
    {
        title: 'Процессы',
        items: [
            {
                title: 'Главная',
                shortTitle: 'Главная',
                path: '/',
                icon: 'home',
            },
            {
                title: 'Очереди приоритета',
                shortTitle: 'Очереди',
                path: '/queues',
                icon: 'queues',
            },
            {
                title: 'Мероприятия',
                shortTitle: 'События',
                path: '/events',
                icon: 'events',
            },
            {
                title: 'Обратная связь',
                shortTitle: 'ОС',
                path: '/feedback',
                icon: 'feedback',
            },
            {
                title: 'Задачи',
                shortTitle: 'Задачи',
                path: '/tasks',
                icon: 'tasks',
            },
        ],
    },
    {
        title: 'Воронки',
        items: [
            {
                title: 'Воронки',
                shortTitle: 'Воронки',
                path: '/engagements?view=bt',
                icon: 'engagements',
            },
            {
                title: 'Договор с АН',
                shortTitle: 'Договор',
                path: '/engagements?view=contract',
                icon: 'contract',
            },
            {
                title: 'Посещенность проекта',
                shortTitle: 'Матрица',
                path: '/engagements/projects',
                icon: 'projects',
            },
            {
                title: 'Воронка агентов',
                shortTitle: 'Воронка',
                path: '/funnel',
                icon: 'funnel',
            },
        ],
    },
    {
        title: 'Справочники',
        items: [
            {
                title: 'Приоритетный список',
                shortTitle: 'Приоритет',
                path: '/priority',
                icon: 'priority',
            },
            {
                title: 'Агенты',
                shortTitle: 'Агенты',
                path: '/agents',
                icon: 'agents',
            },
            {
                title: 'Агентства',
                shortTitle: 'АН',
                path: '/agencies',
                icon: 'agencies',
            },
            {
                title: 'Фиксации',
                shortTitle: 'Фиксации',
                path: '/fixations',
                icon: 'fixations',
            },
            {
                title: 'Бренд-менеджеры',
                shortTitle: 'БМ',
                path: '/brand-managers',
                icon: 'brandManagers',
            },
            {
                title: 'Расшифровки',
                shortTitle: 'Расшифровки',
                path: '/transcriptions',
                icon: 'transcriptions',
            },
        ],
    },
];
/** Полное меню P0 (плоский список из разделов). */
export const NAV_ITEMS = NAV_SECTIONS.flatMap((section) => section.items);
/** Primary tabs compact (&lt; lg). Остальное — в «Ещё». Полный path, с query. */
export const BOTTOM_NAV_PRIMARY_PATHS = [
    '/',
    '/queues',
    '/engagements?view=bt',
    '/tasks',
];
export const BOTTOM_NAV_MORE_PATHS = [
    '/engagements?view=contract',
    '/engagements/projects',
    '/events',
    '/priority',
    '/funnel',
    '/feedback',
    '/agents',
    '/agencies',
    '/fixations',
    '/brand-managers',
    '/transcriptions',
];
export const BOTTOM_NAV_PRIMARY = NAV_ITEMS.filter((item) => BOTTOM_NAV_PRIMARY_PATHS.includes(item.path));
export const BOTTOM_NAV_MORE = NAV_ITEMS.filter((item) => BOTTOM_NAV_MORE_PATHS.includes(item.path));
/** Разделы «Ещё» на compact: те же заголовки, только пункты из BOTTOM_NAV_MORE. */
export const BOTTOM_NAV_MORE_SECTIONS = NAV_SECTIONS.map((section) => ({
    title: section.title,
    items: section.items.filter((item) => BOTTOM_NAV_MORE_PATHS.includes(item.path)),
})).filter((section) => section.items.length > 0);
